import React from 'react'
import Header from './Components/Header';
import ListingSaleComp from './Components/ListingSaleComp';
import Footer from './Components/Footer';


function ListingSale() {

    return (
        <div>
            <Header />
            <ListingSaleComp />
            <Footer />
        </div>
    )
}

export default ListingSale